import { React, useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ImageSlider from "./components/ImageSlider";
import images from "./components/Images";
import Hero2 from "./components/Hero2";

const App = () => {
  return (
    <div>
    <Navbar/>
    <Hero/>
    
    <div className="App">
    <ImageSlider images={images}/>
  </div>
    <Hero2/>
  
    </div>

  );
};

export default App;
